export default {"src":"/_next/static/media/logo-dema1n.5feef928.svg","height":100,"width":232};